import type { Theme } from "@mui/material";
import StatusChip from "@entrilia/shared/components/StatusChip";
import type { SmartViewArtifact } from "../../../../../api/types/smartViewArtifactsTypes";
import type { ArtifactStatus } from "./artifactStatus";
import { getArtifactStatus } from "./artifactStatus";

const toneColors: Record<ArtifactStatus["tone"], (theme: Theme) => string> = {
  published: (theme) => theme.palette.success.main,
  changes: (theme) => theme.palette.warning.main,
  draft: (theme) => theme.palette.text.secondary,
};

interface Props {
  artifact: Pick<SmartViewArtifact, "publishedVersion" | "latestVersion">;
}

const ArtifactStatusChip = ({ artifact }: Props) => {
  const { label, tone } = getArtifactStatus(artifact);
  return <StatusChip label={label} color={toneColors[tone]} withDot />;
};

export default ArtifactStatusChip;
